import { esCafeteriaPalettes } from "../../../../Posts/05-tematicas/08-cafeterias/cafeteriaPalettes.js";
import * as React from 'react';
export default {
  esCafeteriaPalettes,
  React
};